import React, { useState } from 'react';
import ChatGemini from './ChatGemini';
import './ChatGeminiFlutuante.css';

function ChatGeminiFlutuante({ apiBaseUrl, chatPath, role = 'analista', descricaoChamado = '', tramites = [] }) {
  const [aberto, setAberto] = useState(false);
  const [maximizado, setMaximizado] = useState(false);

  const toggleAberto = () => setAberto((a) => !a);
  const minimizar = () => setAberto(false);
  const toggleMaximizado = () => setMaximizado((m) => !m);

  return (
    <>

      {!aberto && (
        <button
          type="button"
          className="chat-flutuante-bubble"
          onClick={toggleAberto}
          title="Abrir Fale com Tacoma"
          aria-label="Abrir Fale com Tacoma"
        >
          <i className="fas fa-comments" />
          <span className="chat-flutuante-bubble-texto">Fale com Tacoma</span>
        </button>
      )}

      {aberto && (
        <div
          className={`chat-flutuante-janela ${maximizado ? 'chat-flutuante-janela--maximizada' : ''}`}
          role="dialog"
          aria-label="Fale com Tacoma"
        >
          <div className="chat-flutuante-header">
            <span className="chat-flutuante-titulo">
              <i className="fas fa-comments" /> Fale com Tacoma
            </span>
            <div className="chat-flutuante-botoes">
              <button
                type="button"
                className="chat-flutuante-btn chat-flutuante-btn--min"
                onClick={minimizar}
                title="Minimizar"
                aria-label="Minimizar"
              >
                <i className="fas fa-minus" />
              </button>
              <button
                type="button"
                className="chat-flutuante-btn chat-flutuante-btn--max"
                onClick={toggleMaximizado}
                title={maximizado ? 'Restaurar' : 'Maximizar'}
                aria-label={maximizado ? 'Restaurar' : 'Maximizar'}
              >
                <i className={maximizado ? 'fas fa-compress' : 'fas fa-expand'} />
              </button>
            </div>
          </div>
          <div className="chat-flutuante-body">
            <ChatGemini
              apiBaseUrl={apiBaseUrl}
              chatPath={chatPath}
              role={role}
              descricaoChamado={descricaoChamado}
              tramites={tramites}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default ChatGeminiFlutuante;
